import * as React from 'react'
import Icon from '../../Icon/Icon'
import { tag } from '../../../services/ATInternetService'

interface IMailState {
  subject: string
  body: string
}
interface IMailProps {
  url: string
}

class Mail extends React.Component<IMailProps, IMailState> {
  constructor(props: IMailProps) {
    super(props)
    this.state = {
      subject: 'Testez votre consommation d’alcool',
      body: encodeURIComponent(
        'Bonjour,\r\n\r\nje viens de faire le point sur ma consommation d’alcool pour savoir quels sont les risques pour ma santé.\r\n\r\nCe test est rapide et anonyme, il pourrait vous intéresser ! ' +
          this.props.url
      ),
    }
  }
  public render() {
    const Mailto = `mailto:?Subject=${this.state.subject}&body=${this.state.body}`
    return (
      <a target="_blank" onClick={this.shareMail} href={Mailto}>
        <Icon name="mail" alt="Partager par email" />
      </a>
    )
  }

  private shareMail = () => {
    tag.sendClick({
      elem: this,
      name: 'share_mail',
      chapter1: 'Resultat',
      type: 'action',
    })
  }
}

export default Mail



// WEBPACK FOOTER //
// ./src/components/Share/SocialMedia/Mail.tsx